module.exports = __webpack_public_path__ + "img/194.64ce5c86.jpg";